var base = require('kiosk/profile');

Vue.component('spark-kiosk-profile', {
    mixins: [base],
    data() {
        return {
            headers: [{
                value: 'photo_url', sortable: false
            },{
                text: 'Name', value: 'name', align: 'left'
            },{
                text: 'Subscription', value: 'subscription', align: 'left'
            }]
        };
    }
});
